<template>
  <div>
    <v-chip v-if="size === 'small'" color="accent" x-small>
      <p class="my-0 pro-badge-small">PRO</p>
    </v-chip>
    <v-chip v-else-if="size === 'medium'" color="accent" small>
      <p class="my-0 pro-badge-small">PRO</p>
    </v-chip>
  </div>
</template>

<script>
export default {
  name: "ProBadge",
  props: {
    size: String,
  }
}
</script>

<style scoped>
.pro-badge-small {
  font: 12px 'Product Sans', sans-serif;
  color: #111111;
  font-weight: bold;
}

.pro-badge-medium {
  font: 14px 'Product Sans', sans-serif;
  color: #111111;
  font-weight: bold;
}
</style>